import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { trackPageView } from './utils/analytics';
import About from "./pages/about"
import Home from "./pages/home"
import Error from "./pages/error"
import Consult from "./pages/consult"
import Career from "./pages/career"
import Seminar from "./pages/seminar"
import Privacy from "./pages/privacy"
import Landing from "./pages/landing"
import CookieConsent from './pages/components/cookieConsent';
import ScrollToTop from './pages/components/scrollToTop';
import SharedLayout from "./pages/sharedLayout.js"
import Navbar from "./pages/components/navbar"
import Footer from "./pages/components/footer"

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return null;
};

export default function Main() {
  return (
    <div className='main'>
      <BrowserRouter>
        <AnalyticsTracker />
        <ScrollToTop />
        <Navbar />
        <div className="content">
          <Routes>
            <Route path="/" element={<SharedLayout />}>
              <Route index element={<Home />} />
              <Route path="apie" element={<About />} />
              <Route path="konsultacija" element={<Consult />} />
              <Route path="karjera" element={<Career />} />
              <Route path="atsiliepimai" element={<Seminar />} />
              <Route path="privatumas" element={<Privacy />} />
              <Route path="nukreipimas" element={<Landing />} />
            </Route>
            <Route path="*" element={<Error />} />
          </Routes>
        </div>
        <Footer />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}